module.exports = __webpack_public_path__ + "img/701_2.693cb252.jpg";